// The shape RunDemonstration needs off a fetched demonstration Skill row.
// Kept permissive (`unknown` payloads) because the row crosses the feathers
// boundary untyped; the helper narrows it.
export interface DemonstrationSkillRow {
  skillType?: string;
  shared?: { recordings?: unknown; activeTooltipOption?: unknown };
}

export interface ResolvedSkillRecording {
  recordingId: string;
  // Tooltip the skill was recorded with (`shared.activeTooltipOption`), when a
  // string. Preferred over the recording's stored refTcpOption for sphere-trim.
  activeTooltipOption: string | undefined;
}

// Validate a fetched demonstration Skill row and pick the recording the runner
// replays: the NEWEST one (`recordings.at(-1)`) — a re-record appends, so the
// last entry is the most recent demonstration. Throws a user-visible message
// when the skill is missing, is not an `ai-motion` skill, or has no recordings.
// Pure (no I/O) so the resolution contract is unit-testable apart from the
// feathers fetch in `RunDemonstrationStep.resolveRecordingId`.
export function resolveSkillRecording(
  skillId: string,
  skill: DemonstrationSkillRow | undefined,
): ResolvedSkillRecording {
  if (!skill) {
    throw new Error(`RunDemonstration: skill ${skillId} not found`);
  }

  if (skill.skillType !== 'ai-motion') {
    throw new Error(
      `RunDemonstration: skill ${skillId} has skillType=${skill.skillType}, expected 'ai-motion'`,
    );
  }

  const recordings = skill.shared?.recordings;

  const activeTooltipOption =
    typeof skill.shared?.activeTooltipOption === 'string'
      ? skill.shared.activeTooltipOption
      : undefined;

  const lastRecording = Array.isArray(recordings)
    ? recordings.at(-1)
    : undefined;

  const recordingId =
    typeof lastRecording === 'string' ? lastRecording : undefined;

  if (!recordingId) {
    throw new Error(`RunDemonstration: skill ${skillId} has no recordings`);
  }

  return { recordingId, activeTooltipOption };
}
